import Vue from 'vue';
import relativeTime from 'dayjs/plugin/relativeTime';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const dayjs = require('dayjs');

dayjs.extend(relativeTime);

Vue.filter('timeAgo', (timestamp: number) => dayjs().to(dayjs(timestamp * 1000)));
Vue.filter('timeAgoDate', (date: Date) => dayjs().to(dayjs(date)));
